import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styles from './index.scss';

const TileCustomLink = ({ children, url, external, cc, lc }) => {
    const linkTo = `/shop/${cc}/${lc}${url}`;

    return external ? (
        <a className={styles.link} href={url}>
            {children}
        </a>
    ) : (
        <Link className={styles.link} to={linkTo}>
            {children}
        </Link>
    );
};

TileCustomLink.propTypes = {
    url: PropTypes.string,
    external: PropTypes.bool,
    lc: PropTypes.string,
    cc: PropTypes.string,
};

export default TileCustomLink;
